import { render, staticRenderFns } from "./WeaponContent.vue?vue&type=template&id=430b1cc6&lang=pug"
import script from "./WeaponContent.vue?vue&type=script&lang=js"
export * from "./WeaponContent.vue?vue&type=script&lang=js"
import style0 from "./WeaponContent.vue?vue&type=style&index=0&id=430b1cc6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports